import React from 'react';
import styled from 'styled-components';

const HeaderDropdownItemWrapper = styled.a`
  box-sizing: border-box;
  font-size: 1.6rem;
  padding: 0.8rem 1.6rem;
  min-width: fit-content;
  width: 100%;
  word-wrap: wrap none;
  text-align: left;
  height: 100%;
  border: 0px;
  background-color: var(--color-white);
  cursor: pointer;
  color: var(--color-black);
  text-decoration: none;
  &:hover {
    background-color: whitesmoke;
  }
`;

const HeaderDropdownItem = ({ title, link, target }) => {
  return (
    <HeaderDropdownItemWrapper href={link} target={target ? '_blank' : '_self'}>
      <span title={title}>{title}</span>
    </HeaderDropdownItemWrapper>
  );
};

export default HeaderDropdownItem;
